import { Injectable } from '@angular/core'
import { CacheService } from './cache.service'
import { ReplaySubject } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class PurchaseHistoryService {
  constructor(private cacheService: CacheService) {}
  products$: any = new ReplaySubject<any>(1)
  getPurchaseHistory() {
    this.cacheService.get('sdpr.getInvoices', null).then((data) => {
      this.products$.next(data)
      return this.products$
    })
  }
}
